import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/login";
import {formToJson} from "../misc/utils";
import Alerts from "../misc/alerts";
import {App} from "../app/app";

export class LoginView extends View {

    static classname = "login-view";

    private readonly server = Server.instance();

    private app : App;

    constructor(app: App, username?: string, password?: string) {
        super(LoginView.classname);
        this.app = app;

        if (username && password) {
            const data = {
                username: username,
                password: password
            }
            this.server.login(data).then((user) => {
                if (user) {
                    this.app.setUser(user);
                    window.location.hash = "/home"
                }
            });

        }
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
        };

        const out = this.pug(template, data);
        out.find(".with-validation").validate({
            rules: {
                username: "required",
                password: "required",
            }
        });

        return out;
    }

    login() {
        const form = this.elt().find(".login-form");

        if (! form.valid()) {
            return;
        }

        const data : { username?: string, password?: string } = {};
        formToJson(form, data);

        this.server.login(data).then((user) => {

            if (user) {

                this.app.setUser(user);

                window.location.hash = "/home"

            } else {
                // Problems
                Alerts.alert("Login failed");
            }
        });

    }

    forgotPassword() {
        const form = this.elt().find(".login-form");
        const data : { username?: string, password?: string } = {};
        formToJson(form, data);
        if (data.username) {
            this.server.sendReset(data.username).then(() => {
                Alerts.alert("An email with a password reset link has been sent to your email address.")
            });
        } else {
            Alerts.alert("Put your username in the username field and try again.")
        }
    }
}

View.on(
    "." + LoginView.classname,
    "click",
    ".login",
    function(that: LoginView, event, elt) {
        event.preventDefault();
        that.login();
    });

View.on(
    "." + LoginView.classname,
    "click",
    ".forgot-password",
    function(that: LoginView, event, elt) {
        event.preventDefault();
        that.forgotPassword();
    });



